import React from 'react';
import { motion } from 'framer-motion';
interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
}
export function ProgressBar({
  currentStep,
  totalSteps
}: ProgressBarProps) {
  const progress = currentStep / totalSteps * 100;
  return <div className="absolute bottom-0 left-0 right-0 px-6 pb-5 pt-3 flex flex-col gap-2 z-20 bg-gradient-to-t from-white via-white/80 to-transparent" data-id="element-98">
      <div className="flex justify-between items-center text-[10px] font-semibold text-slate-500 tracking-widest uppercase" data-id="element-99">
        <span data-id="element-100">Progress</span>
        <span data-id="element-101">
          {currentStep} / {totalSteps}
        </span>
      </div>
      <div className="h-[3px] w-full bg-slate-200 rounded-full overflow-hidden" data-id="element-102">
        <motion.div className="h-full bg-gradient-to-r from-minerva-blue to-minerva-cyan shadow-[0_0_10px_rgba(0,133,189,0.4)] rounded-full" initial={{
        width: 0
      }} animate={{
        width: `${progress}%`
      }} transition={{
        duration: 0.5,
        ease: 'easeInOut'
      }} data-id="element-103" />
      </div>
    </div>;
}